import {RequestFormFieldType, RequestFormType} from "../const/const"
import {FieldType} from "../../../../core/fields3/field-type"
import RequestFormField from "../model/settings/field"

export enum MandatoryFieldsIds {
    NAME    = 'request-user-name',
    EMAIL   = 'request-user-email',
    TITLE   = 'title'               // same as task field id
}

const debug = false
// const debug = "getMandatoryFormFields"

export default function getMandatoryFormFields(requestFormType:RequestFormType) {
    let requestFormFields = []

    switch (requestFormType) {
        case RequestFormType.FORM:
            /** USER NAME FIELD **/
            const requestFormFieldName = new RequestFormField({
                type            : RequestFormFieldType.FORM,
                formFieldConfig : {
                    fieldId : MandatoryFieldsIds.NAME,
                    type    : FieldType.STRING,
                },
                label           : 'Your name',
                description     : '',
                isRequired      : true,
                isMandatory     : true,
            })
            requestFormFields.push(requestFormFieldName)

            /** USER EMAIL FIELD **/
            const requestFormFieldEmail = new RequestFormField({
                type            : RequestFormFieldType.FORM,
                formFieldConfig : {
                    fieldId : MandatoryFieldsIds.EMAIL,
                    type    : FieldType.EMAIL,
                },
                label           : 'Your email address',
                description     : '',
                isRequired      : true,
                isMandatory     : true,
            })
            requestFormFields.push(requestFormFieldEmail)
            break
    }

    /** REQUEST TITLE FIELD **/
    const requestFormField = new RequestFormField({
        type        : RequestFormFieldType.TASK,
        taskFieldId : MandatoryFieldsIds.TITLE,
        label       : 'Title',
        description : '',
        isRequired  : true,
        isMandatory : true,
    })
    requestFormFields.push(requestFormField)

    return requestFormFields
}